export default __webpack_public_path__ + "static/media/4.68b6fce6.jpg";